import { useContext, useEffect, useState } from "react";
import getOverviewAvatars from "../../../domain/use_cases/leedflow/overview/getOverviewAvatars";
import AuthenticationContext from "../../contexts/auth/AuthenticationContext";

/**
 * Avatars par uid, chargés une fois les chiffres affichés. Un échec laisse la
 * pastille par défaut : une photo manquante ne vaut pas une erreur à l'écran.
 */
export const useOverviewAvatars = (uids: string[]) => {
    const authContext = useContext(AuthenticationContext);
    const auth = authContext.authentication;
    const [avatars, setAvatars] = useState<Record<string, string>>({});

    // Clé stable : un nouveau tableau aux mêmes uid ne doit pas relancer la requête.
    const key = [...uids].sort().join(',');

    useEffect(() => {
        if (!auth || !key) return;

        let cancelled = false;
        (async () => {
            try {
                const res = await getOverviewAvatars(auth, key.split(','));
                if (!cancelled) setAvatars(res);
            } catch (error) {
                console.error(error);
            }
        })();

        return () => {
            cancelled = true;
        };
    }, [auth, key]);

    return avatars;
};
